// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');

const { filterPgContracts } = require('../reducers/brokerCustomWalletParseHelper');

const getContractsListByPortfolioSuccess = (data, idPortfolioAccount, enabledProducts) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_SUCCESS,
    payload: data,
    idPortfolioAccount,
    enabledProducts
});

const getContractsListByPortfolioError = (idPortfolioAccount, error) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_ERROR,
    payload: error,
    idPortfolioAccount,
});

const getContractsListByPortfolioRequest = (idPortfolioAccount) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_REQUEST,
    payload: idPortfolioAccount,
});

const getDetailsByPortfolio = portfolioAccountId => (dispatch, getState) => {
    const requestData = {
        query: {
            portfolioAccountId,
        },
    };

    dispatch(getContractsListByPortfolioRequest(portfolioAccountId));
    
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerCustomWalletGetContracts'),
        requestData
    )
        .then(response => {
            const pgContracts = getState().brokerMyInvestments.get('contracts');
            const filteredResponse = filterPgContracts(pgContracts, response);
            APIGet(
                dispatch,
                apiURLBuilder.getURL('brokerFundsEnabledProducts'),
            ).then(response => {
                const {enabledProducts} = response
                dispatch(getContractsListByPortfolioSuccess(filteredResponse, portfolioAccountId, enabledProducts));
            })
            
        })
        .catch(error => {
            dispatch(getContractsListByPortfolioError(portfolioAccountId, error));
        });
};

const updatePortfolio = (newName, newContracts, portfolioAccountId) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_UPDATE_CONTRACTS_LIST_BY_PORTFOLIO,
    payload: {
        portfolioAccountId,
        newName,
        newContracts
    }
});

module.exports = {
    getDetailsByPortfolio,
    updatePortfolio
};
